import * as types from '../../constants/actionTypes';

export default function set(id = false) {
	return {
		type: types.ADMIN_NOTIFICATION_SET,
		payload: {
			id,
		},
	};
}



// WEBPACK FOOTER //
// ./src/actions/adminNotifications/setAdminNotification.js